import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Typography from '@/v2/components/common/Typography'
import MobileConversationsList from './MobileConversationsList'
import MobileMessagesPage from './MobileMessagesPage'
import { Container, Header, Content } from './styles'

const MobileMessages = () => {
  const { conversationId } = useParams()
  const navigate = useNavigate()
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  const updateKeyboardHeight = useCallback(() => {
    if (window.visualViewport) {
      const viewportHeight = window.visualViewport.height
      const windowHeight = window.innerHeight
      const heightDiff = windowHeight - viewportHeight
      // Considera teclado aberto se a diferença for maior que 100px
      setKeyboardHeight(heightDiff > 100 ? heightDiff : 0)
    }
  }, [])

  useEffect(() => {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateKeyboardHeight)
      window.visualViewport.addEventListener('scroll', updateKeyboardHeight)
      return () => {
        window.visualViewport.removeEventListener(
          'resize',
          updateKeyboardHeight
        )
        window.visualViewport.removeEventListener(
          'scroll',
          updateKeyboardHeight
        )
      }
    }
  }, [updateKeyboardHeight])

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Container $keyboardHeight={keyboardHeight}>
      <Header>
        <IconButton onClick={handleBack} size="small">
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h2" fontSize="16px" fontWeight="500">
          Messages
        </Typography>
      </Header>
      <Content>
        {conversationId ? (
          <MobileMessagesPage key={conversationId} />
        ) : (
          <MobileConversationsList />
        )}
      </Content>
    </Container>
  )
}

export default MobileMessages
